<template>
  <div class="download_page" :style="styleObj">
    <div class="top_banner">
      <img class="top_logo" src="../../assets/tfsharelogo.png" alt="">
      <div class="middel-info">
        <div>铁粉生活</div>
        <div class="s_text">湖南广电旗下唯一本地生活服务APP</div>
      </div>
      <div id="btn_open">打开APP</div>
    </div>
    <div class="manage_info" v-if="roomInfo && roomInfo.professorList && roomInfo.professorList.length > 0">
      <img :src="roomInfo.professorList[0].imageUrl" alt="">
      <span>{{roomInfo.professorList[0].name}}</span>
    </div>
    <div class="room_info">
      <div class="num_item"><img src="../../assets/money.png" alt="">打赏 {{roomInfo.rewardCount}}</div>
      <div class="num_item"><img src="../../assets/praise.png" alt="">点赞 {{roomInfo.praisesNum}}</div>
      <div class="num_item dot"><img src="../../assets/dot.png" alt="">{{roomInfo.onlineNum}} 在线</div>
    </div>
    <div class="live">
      <div id="dplayer" :style="playerStyleObj"></div>
    </div>
    <div class="message_container" ref="container">
      <div class="message_block" v-for="(item, index) in commentList" :key="index">
        <div class="message_item">
          <span class="user_name" v-if="item.message.content.msgType != 303">{{item.message.from.userName}}：</span>
          <span class="message" v-if="item.message.content.msgType == 400">管理员禁言了直播间</span>
          <span class="message" v-else-if="item.message.content.msgType == 401">管理员解除了直播间禁言</span>
          <span class="message" v-else-if="item.message.content.msgType == 402">
            {{item.message.content.targetUser.userName}}已被禁言
          </span>
          <span class="message" v-else-if="item.message.content.msgType == 403">
            {{item.message.content.targetUser.userName}}的禁言解除
          </span>
          <span class="message" v-else-if="item.message.content.msgType == 404">
            {{item.message.content.targetUser.userName}}被踢出直播间
          </span>
          <span class="message" v-else-if="item.message.content.msgType == 405">
            <el-image :src="item.message.content.attach.linkImageUrl" style="height: 50px;width: 50px;" v-if="item.message.content.attach.linkType != -1"></el-image>
              <div class="text" v-if="item.message.content.attach.linkType == -1">删除了链接</div>
              <div class="text" v-else>{{item.message.content.attach.linkText}}</div>
          </span>
          <span class="message" v-else-if="item.message.content.msgType == 303">
            {{item.message.from.userName}}赠送给主播{{item.message.content.attach.hostName}}{{item.message.content.attach.giftName}}
            <img :src="item.message.content.attach.url" class="gift_img" alt="">
            <span v-if="item.message.content.attach.giftCount">×{{item.message.content.attach.giftCount}}</span>
          </span>
          <span class="message" v-else-if="item.message.content.msgType == 1">{{item.message.content.text}}</span>
          <span class="message" v-else-if="item.message.content.msgType == 2">
            <el-image :src="item.message.content.attach.url" style="height: 50px;width: 50px;flex-shrink: 0;padding-left: 5px;"></el-image>
          </span>
          <span v-else-if="item.message.content.msgType == 3">
            <audio :src="item.message.content.attach.url" controls="controls"
                   style="height:54px;width: 200px;"></audio>
          </span>
          <span v-else-if="item.message.content.msgType == 4">
            <video :src="item.message.content.attach.url" controls="controls" style="height:100px;"></video>
          </span>
        </div>
      </div>
    </div>
    <Spin fix size="large" v-if="loading || roomLoading"></Spin>
  </div>
</template>

<script>
let Hls = require('hls.js');
import DPlayer from 'dplayer';
import moment from 'moment'
const CryptoJS = require('crypto-js');
const PahoMQTT = require('paho.mqtt.js');
export default {
  name: "liveroom",
  data() {
    return {
      loading: true,
      roomLoading: true,
      styleObj: {},
      playerStyleObj: {},
      roomId: 0,
      rewardAmount: 0,
      praiseNum: 0,
      onlineNum: 0,
      contentHeight: document.documentElement.clientHeight,
      instanceId: '',
      host: '',
      port: 80,
      topic: '',
      useTLS: false,
      accessKey: '',
      secretKey: '',
      groupId: '',
      clientId: '',
      mqtt: null,
      username: '',
      password: '',
      client: null,
      commentList: [],
      roomInfo: {},
    }
  },
  mounted() {
    this.styleObj = {
      height: (this.contentHeight - 55) + 'px',
      marginTop: '55px'
    }
    let param = this.$route.query
    this.roomId = param.id

    // linkType(7:直播间)
    var data = XInstall.parseUrlParams();
    new XInstall({
      appKey : "mq81ipn",
      buttonId: [
        { idName: 'btn_open', params: {linkType: 7, linkId: param.id} }
      ]
    }, data);

    this.connectMqtt()
    this.getRoomDetail()
    this.getCommentList()
  },
  methods: {
    connectMqtt() {
      let that = this
      this.$http.getOssConf('/mqtt/getConfig', {}, function (res) {
        that.instanceId = res.data.instanceId
        that.host = res.data.endPoint
        that.port = res.data.port
        that.topic = res.data.parentTopic
        that.accessKey = res.data.accessKey
        that.secretKey = res.data.secretKey
        that.groupId = res.data.groupId
        that.clientId = that.groupId + '@@@' + that.getUuid()
        that.username = 'Signature|' + that.accessKey + '|' + that.instanceId;//username和 Password 签名模式下的设置方法，参考文档 https://help.aliyun.com/document_detail/48271.html?spm=a2c4g.11186623.6.553.217831c3BSFry7
        that.password = CryptoJS.HmacSHA1(that.clientId, that.secretKey).toString(CryptoJS.enc.Base64);

        that.mqtt = new PahoMQTT.Client(that.host, parseInt(that.port), that.clientId)
        let options = {
          timeout: 3,
          onSuccess: that.onConnect,
          mqttVersion: 4,
          cleanSession: true,
          onFailure: function (message) {
            setTimeout(that.connectMqtt, 2000)
          }
        };
        that.mqtt.onConnectionLost = that.onConnectionLost
        that.mqtt.onMessageArrived = that.onMessageArrived
        if (that.username != null) {
          options.userName = that.username;
          options.password = that.password;
          options.useSSL = true;//如果使用 HTTPS 加密则配置为 true
        }
        that.mqtt.connect(options);
      }, function () {
      })
    },
    onConnect() {
      // 订阅聊天消息
      this.mqtt.subscribe(this.topic + '/message/' + this.roomId, {qos: 0})
      // 订阅系统消息
      this.mqtt.subscribe(this.topic + '/system/' + this.roomId, {qos: 0})
      // 订阅通知消息
      this.mqtt.subscribe(this.topic + '/notification/' + this.roomId, {qos: 0})
    },
    onConnectionLost(responseObject) {
      setTimeout(this.connectMqtt, 2000)
    },
    onMessageArrived(message) {
      let msg = JSON.parse(message.payloadString)
      if (msg.content && msg.content.msgType
        && (msg.content.msgType == 1 || msg.content.msgType == 2 || msg.content.msgType == 3 || msg.content.msgType == 4
          || msg.content.msgType == 100 || msg.content.msgType == 303 || msg.content.msgType == 400
          || msg.content.msgType == 401 || msg.content.msgType == 405 || msg.content.msgType == 421)) {
        this.commentList.push({
          isShutUp: 0,
          createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          message: msg
        })
      } if (msg.content && msg.content.msgType && msg.content.msgType == 402) {
        // 单独禁言
        this.commentList.push({
          isShutUp: 1,
          createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          message: msg
        })
        for (let item of this.commentList) {
          if (item.message.from.userId == msg.content.targetUser.userId) {
            item.isShutUp = true
          }
        }
      } else if (msg.content && msg.content.msgType && msg.content.msgType == 403) {
        // 单独解除禁言
        this.commentList.push({
          isShutUp: 0,
          createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          message: msg
        })
        for (let item of this.commentList) {
          if (item.message.from.userId == msg.content.targetUser.userId) {
            item.isShutUp = false
          }
        }
      } else if (msg.content && msg.content.msgType && msg.content.msgType == 406) {
        // 刷新在线人数
        this.roomInfo.onlineNum = msg.content.count || 0
      } else if (msg.content && msg.content.msgType && msg.content.msgType == 407) {
        // 刷新点赞数
        this.roomInfo.praisesNum = msg.content.count || 0
      } else if (msg.content && msg.content.msgType && msg.content.msgType == 408) {
        // 刷新打赏金额
        this.roomInfo.rewardCount = msg.content.count || 0
      } else if (msg.content && msg.content.msgType && msg.content.msgType == 422) {
        // 422:刷新助力值
        let lotteryInfo = msg.content.songInfo
        for (let i = 0; i < this.songSetupList.length; i++) {
          let item = this.songSetupList[i]
          if (item.id === lotteryInfo.id) {
            for (let j = 0; j < item.songList.length; j++) {
              let sItem = item.songList[j]
              if (sItem.lotteryDetailId === lotteryInfo.lotteryDetailId) {
                this.songSetupList[i].songList[j].rewardCount = lotteryInfo.rewardCount
                this.songSetupList[i].songList[j].uvNum = lotteryInfo.uvNum
                break
              }
            }
            break
          }
        }
      }
      let that = this
      this.$nextTick(function () {
        that.$refs.container.scrollTop = that.$refs.container.scrollHeight
      })
    },
    getRoomDetail() {
      let searchParam = {
        id: this.roomId
      }
      let that = this
      this.roomLoading = true
      this.$http.get('/appLiveRoom/open/info', searchParam, function (res) {
        that.roomInfo = res.data
        let url = that.roomInfo.pullUrl
        if (that.roomInfo.liveType === 2) {
          // 视频直播间
          if (url.startsWith('rtmp')) {
            url = url.replace('rtmp://pull.hnradio.vip', process.env.HOST_URL + '/videolive')
            let urlArr = url.split('?')
            url = urlArr[0] + '.m3u8?' + urlArr[1]
            that.$nextTick(function() {
              that.live(true, url)
            })
          } else {
            that.$nextTick(function() {
              that.live(false, url)
            })
          }
        } else {
          // 音频直播间
          url = url.replace('http://a.live.hnradio.com', process.env.HOST_URL + '/audiolive')
          that.playerStyleObj = {
            height: '60px!important'
          }
          that.$nextTick(function() {
            that.live(true, url)
          })
        }
        that.roomLoading = false
      }, function () {
        that.roomInfo = {}
        that.roomLoading = false
      })
    },
    getCommentList() {
      let searchParam = {
        roomId: this.roomId,
        pageIndex: 1,
        pageSize: 10
      }
      let that = this
      that.loading = true
      this.$http.post('/appLiveRoomComment/open/list', searchParam, function (res) {
        let list = []
        if (res.data.records) {
          for (let item of res.data.records) {
            item.message = JSON.parse(item.message)
            list.unshift(item)
          }
        }
        that.commentList = list
        that.$nextTick(function () {
          that.$refs.container.scrollTop = that.$refs.container.scrollHeight
        })
        that.loading = false
      }, function () {
        that.commentList = []
        that.loading = false
      }, 'json')
    },
    getUuid() {
      let uid = [];
      let hexDigits = "0123456789abcdefghijklmnopqrst";
      for (let i = 0; i < 32; i++) {
        uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      uid[6] = "4";
      uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1);
      let uuid = uid.join("");
      return uuid;
    },
    live(isLive, url){
      if (isLive) {
        const dp = new DPlayer({
          live: true,
          autoplay: true,
          hotkey: false,
          container: document.getElementById('dplayer'),
          video: {
            url: url, // 示例地址
            type: 'customHls',
            customType: {
              customHls: function (video, player) {
                const hls = new Hls();
                hls.loadSource(video.src);
                hls.attachMedia(video);
              },
            },
          },
        });
        if (this.roomInfo.liveType === 2 && this.roomInfo.videoShowType === 1) {
          dp.fullScreen.request('web')
        }
      } else {
        const dp = new DPlayer({
          live: true,
          autoplay: true,
          hotkey: false,
          container: document.getElementById('dplayer'),
          video: {
            url: url,
            type: 'auto'
          },
        });
        if (this.roomInfo.liveType === 2 && this.roomInfo.videoShowType === 1) {
          dp.fullScreen.request('web')
        }
      }
    }
  }
}
</script>

<style scoped>
.download_page {
  position: relative;
  background: url("../../assets/bg.png") no-repeat center center;
  background-size: cover;
}

.top_banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  background: rgb(255, 255, 255);
  padding: 6px;
  color: #000;
  border-bottom: 1px solid #eee;
}
.top_logo {
  width: 40px;
  border-radius: 6px;
}
.middel-info {
  flex: 1;
  margin-left: 6px;
  font-size: 16px;
}
.s_text {
  font-size: 12px;
  color: rgba(153,153,153,1);
}
#btn_open {
  background-color: #3C74F2;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 20px;
  color: #fff;
}
.manage_info {
  position: fixed;
  top: 10px;
  left: 10px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  padding-right: 40px;
  z-index: 2;
}
.manage_info img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
}
.room_info {
  position: fixed;
  left: 0;
  width: 100%;
  padding: 0 10px;
  top: 70px;
  display: flex;
  justify-content: space-between;
  z-index: 2;
}
.num_item {
  line-height: 30px;
  padding: 0 10px;
  min-width: 90px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  color: #fff;
  text-align: center;
  font-size: 13px;
}
.num_item img {
  width: 13px;
  vertical-align: middle;
  margin-right: 5px;
}
.num_item.dot img {
  width: 5px;
}
.message_container {
  position: fixed;
  bottom: 0;
  height: 300px;
  left: 0;
  right: 0;
  padding: 15px;
  overflow: auto;
  color: #fff;
  z-index: 99;
}
.message_block {
  margin-bottom: 10px;
}
.message_item {
  line-height: 30px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 15px;
  display: inline-block;
  width: auto;
  padding: 0 10px;
}
.user_name {
  color: #FFB423;
}
.gift_img {
  display: inline-block;
  vertical-align: middle;
  height: 30px;
  margin-top: -4px;
}
.audio_container {
  position: absolute;
  top: 130px;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  color: #fff;
  overflow: auto;
}
.line {
  height: 1px;
  background: #CCCCCC;
  opacity: 0.2;
}
.audio_message {
  display: flex;
  padding: 10px 0;
}
.audio_head_img {
  width: 40px;
  flex-shrink: 0;
}
.audio_head_img img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.live {
  position: fixed;
  top: 120px;
  width: 100%;
}
#dplayer{
  width: 100%;
  height: 230px;
  z-index: 1;
}
/deep/ .dplayer-controller {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/liveroom.vue